export function cleanObjectUndefined<T extends object>(obj: T): T {
  return Object.entries(obj).reduce((acc: any, [key, value]) => {
    if (value !== undefined) {
      acc[key] = value;
    }

    return acc;
  }, {} as T) as T;
}
